import { Component, OnInit, NgZone, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CityService } from '../services/city.service';
import { MarkService } from '../services/mark.service';
import { ModelService } from '../services/model.service';
import { ConceptService } from '../services/concept.service';
import { ServicePremiumService } from '../services/servicePremium.service';
import { TemplateEmailService } from '../services/templateEmail.service';
import { EmailService } from '../services/email.service';
import { Mark } from '../models/mark';
import { Model } from '../models/model';
import { ServicePrmium } from '../models/servicePremium';
import { Concept } from '../models/concept';
import { City } from '../models/agenda.model';
import { TemplateEmail } from '../models/templateEmail';
import { NameValue } from '../models/nameValue';
import { AgendaProConst } from '../models/constantesAgendaPro';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DepartmentService } from '../services/department.service';
import { Department } from '../models/department';
import { SelectItem } from 'primeng/api';


declare var $: any;
declare var google: any;

@Component({
    selector: 'app-landing',
    templateUrl: './landing1.component.html',
    styleUrls: ['./landing.component.css'],
    providers: [CityService, MarkService, ModelService, ConceptService, ServicePremiumService, TemplateEmailService, EmailService, DepartmentService]
})

export class LandingComponent implements OnInit, AfterViewInit {
    public inicio: boolean;
    public equipoReparacion: boolean;
    public domicilio: boolean;
    public contacto: boolean;
    public terminos: boolean;
    public gracias: boolean;
    public garantia: boolean;
    public listMarks: Mark[];
    public listModels: Model[] = [];
    public agendaPro: ServicePrmium;
    public listConcepto: Concept[];
    public listCities: City[];
    public template: TemplateEmail;
    public variables: string[] = [];
    public variables1: NameValue;
    public listVariables: NameValue[] = [];
    public loading: boolean;
    public modeloValidate: boolean;
    public mark: number;
    public model: number;
    public concept: number;
    public city: number;
    public departmentId: number;
    public identification: string;
    public phone: string;
    public componentForm: any;
    public autocomplete: any;
    address: Object;
    establishmentAddress: Object;
    formattedAddress: string;
    formattedEstablishmentAddress: string;
    public lat: number;
    public ln: number;
    typeInput: string;
    public listDepartments: Department[];
    public dropdownDepartments: SelectItem[];
    public tooltipEmei: string;
    public disabledButton: boolean;
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _cityService: CityService,
        private _markService: MarkService,
        private _modelService: ModelService,
        private _conceptService: ConceptService,
        private _servicePremiumService: ServicePremiumService,
        private _templateEmailService: TemplateEmailService,
        private _emailService: EmailService,
        public zone: NgZone,
        private _departmentService: DepartmentService,
    ) {
        this.inicio = true;
        this.equipoReparacion = false;
        this.domicilio = false;
        this.contacto = false;
        this.terminos = false;
        this.gracias = false;
        this.garantia = false;
        this.agendaPro = new ServicePrmium();
        this.agendaPro.nroTicket = '';
        this.mark = 0;
        this.model = 0;
        this.concept = 0;
        this.city = 0;
        this.departmentId = 0;
        this.agendaPro.departmentId = 0;
        this.identification = '';
        this.phone = '';
        this.agendaPro.aceptShipping = false;
        this.agendaPro.aceptPolicy = false;
        this.variables1 = new NameValue();
        this.template = new TemplateEmail();
        this.agendaPro.conceptId = 1;
        this.agendaPro.markId = 2;
        this.agendaPro.entryRepair = "NA";
        this.componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            country: 'long_name',
            postal_code: 'short_name'
        };
        this.typeInput = 'hidden'
        this.tooltipEmei = 'Para ver el IMEI puedes digitar en el celular *#06#, o verlo en la caja del telefono o en la bandeja SIM del dispositivo';
    }
    ngOnInit() {
        this.getMarca();
        this.getConcepto();
        this.getDepartment();
        this.getTemplateEmail();
        this.getModelos(2);
        this.iniciar_geolocalizacion();
    }
    ngAfterViewInit() {

    }
    getMarca() {
        this._markService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listMarks = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    /*changeMarca() {
        this.listModels = [];
        this.agendaPro.modelId = 0;
        this.getModelos(this.mark);
    }*/
    getModelos(marcaid) {
        this.modeloValidate = false;
        this._modelService.getByMarkId(marcaid, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listModels = response.object;
                    this.modeloValidate = true;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    getConcepto() {
        this._conceptService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listConcepto = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    changeConcepto() {
        if (this.concept == 3) {
            this.inicio = false;
            this.equipoReparacion = false;
            this.domicilio = false;
            this.contacto = false;
            this.terminos = false;
            this.gracias = false;
            this.garantia = true;
        }
    }
    getDepartment() {
        this._departmentService.getByCountryId(46, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listDepartments = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    changeDepartment() {
        this.listCities = [];
        this.getCities(this.departmentId);
    }
    getCities(departmentId) {
        this._cityService.getByDepartmentIdS(departmentId, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listCities = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    /*getCities() {
        this._cityService.getByDepartmentId(3, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listCities = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }*/
    setRedirect(){
        window.location.href='https://wts.woden.com.co/wdrp/ConsultaODS';
    }
    createAgendaPro() {
        this.loading = true;
        this.disabledButton = true;
        this.agendaPro.date = new Date();
        this.agendaPro.cityId = Number(this.city);
        this.agendaPro.conceptId = Number(this.concept);
        this.agendaPro.conceptId = 1;
        this.agendaPro.markId = 2;
        this.agendaPro.identification = "0";
        this.agendaPro.modelId = Number(this.model);
        this.agendaPro.phone = String(this.phone);
        if(this.agendaPro.address == undefined) {
            this.agendaPro.address = JSON.parse(localStorage.getItem('address'));
        }
        this.agendaPro.departmentId = Number(this.departmentId);
        this.variables.forEach(vr => {
            if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.fecha) {
                this.variables1.name = 'fecha';
                this.variables1.value = this.agendaPro.date.toDateString();
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.direccion) {
                this.variables1.name = 'direccion';
                this.variables1.value = String(this.agendaPro.address);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.correo) {
                this.variables1.name = 'correo';
                this.variables1.value = String(this.agendaPro.email);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.identificacion) {
                this.variables1.name = 'identificacion';
                this.variables1.value = String(this.agendaPro.identification);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.nombre) {
                this.variables1.name = 'nombre';
                this.variables1.value = String(this.agendaPro.name);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.telefono) {
                this.variables1.name = 'telefono';
                this.variables1.value = String(this.agendaPro.phone);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            }
        });
        if (this.agendaPro.aceptPolicy == false || this.agendaPro.address == undefined || this.agendaPro.name == undefined
            || this.agendaPro.phone == undefined || this.agendaPro.email == undefined 
            || this.agendaPro.imei == undefined || this.agendaPro.modelId == 0 || this.agendaPro.cityId == 0) {
            this.loading = false;
            alert('Por favor diligencie todos los datos');
            this.disabledButton = false;
        } else {
            this._servicePremiumService.create(this.agendaPro).subscribe(
                response => {
                    if (response.statusCode === '200 OK') {
                        this.sendEmail(this.listVariables, 1, this.agendaPro.email, this.agendaPro.name, this.agendaPro.aceptShipping);
                    } else {
                        this.loading = false;
                        console.log(response);
                        alert('Error al procesar su solicitud. El IMEI que intenta ingresar ya se encuentra registrado');
                        this.disabledButton = false;
                    }
                },
                error => {
                    alert('Error en la aplicacion');
                    this.loading = false;
                    console.log(<any>error);
                }
            );
        }
    }
    getTemplateEmail() {
        this._templateEmailService.getById(1).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.template = response.object;
                    this.variables = this.template.variable.split(',');
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    sendEmail(entity, templateId, emailaddress, name, aceptaEnvio) {
        this._emailService.create(entity, templateId, emailaddress, name, aceptaEnvio).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.agendaPro = new ServicePrmium();
                    this.disabledButton = false;
                    this.inicio = false;
                    this.equipoReparacion = false;
                    this.domicilio = false;
                    this.contacto = false;
                    this.terminos = false;
                    this.gracias = true;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    nextStep() {
        if (this.inicio == true && this.equipoReparacion == false && this.domicilio == false && this.contacto == false && this.terminos == false) {
            this.equipoReparacion = false;
            this.terminos = false;
            this.domicilio = false;
            this.inicio = false;
            this.contacto = true;
        } else if (this.inicio == false && this.equipoReparacion == false && this.domicilio == false && this.contacto == true && this.terminos == false) {
            this.equipoReparacion = true;
            this.domicilio = false;
            this.terminos = false;
            this.inicio = false;
            this.contacto = false;
        } else if (this.inicio == false && this.equipoReparacion == false && this.domicilio == true && this.contacto == false && this.terminos == false) {
            this.equipoReparacion = true;
            this.domicilio = false;
            this.terminos = false;
            this.contacto = false;
            this.inicio = false;
        } else if (this.inicio == false && this.equipoReparacion == true && this.domicilio == false && this.contacto == false && this.terminos == false) {
            this.equipoReparacion = false;
            this.domicilio = false;
            this.terminos = true;
            this.contacto = false;
            this.inicio = false;
        }
    }
    backStep() {
        if (this.equipoReparacion == false && this.domicilio == true && this.contacto == false && this.terminos == false) {
            this.equipoReparacion = false;
            this.domicilio = false;
            this.terminos = false
            this.contacto = true;
        } else if (this.equipoReparacion == false && this.domicilio == false && this.contacto == true) {
            this.equipoReparacion = false;
            this.domicilio = false;
            this.contacto = false;
            this.terminos = false
            this.inicio = true;
        } else if (this.equipoReparacion == false && this.domicilio == false && this.contacto == false && this.terminos == true) {
            this.equipoReparacion = true;
            this.domicilio = false;
            this.terminos = false
            this.contacto = false;
        } else if (this.equipoReparacion == true && this.domicilio == false && this.contacto == false && this.terminos == false) {
            this.equipoReparacion = false;
            this.domicilio = false;
            this.terminos = false
            this.contacto = true;
            this.inicio = false;
        }
    }
    getAddress(place: object) {
        this.address = place['formatted_address'];
        this.agendaPro.address = this.address.toString();
        if(this.agendaPro.address == null) {
            this.typeInput = 'text';
        }
        this.phone = this.getPhone(place);
        this.formattedAddress = place['formatted_address'];
        this.zone.run(() => this.formattedAddress = place['formatted_address']);
      }    
      getEstablishmentAddress(place: object) {
        this.establishmentAddress = place['formatted_address'];
        this.phone = this.getPhone(place);
        this.formattedEstablishmentAddress = place['formatted_address'];
        this.zone.run(() => {
          this.formattedEstablishmentAddress = place['formatted_address'];
          this.phone = place['formatted_phone_number'];
        });
      }    
      getAddrComponent(place, componentTemplate) {
        let result;    
        for (let i = 0; i < place.address_components.length; i++) {
          const addressType = place.address_components[i].types[0];
          if (componentTemplate[addressType]) {
            result = place.address_components[i][componentTemplate[addressType]];
            return result;
          }
        }
        return;
      }
 
      getStreetNumber(place) {
        const COMPONENT_TEMPLATE = { street_number: 'short_name' },
          streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return streetNumber;
      }
    
      getStreet(place) {
        const COMPONENT_TEMPLATE = { route: 'long_name' },
          street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return street;
      }
    
      getCity(place) {
        const COMPONENT_TEMPLATE = { locality: 'long_name' },
          city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return city;
      }
    
      getState(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
          state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state;
      }
    
      getDistrict(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
          state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state;
      }
    
      getCountryShort(place) {
        const COMPONENT_TEMPLATE = { country: 'short_name' },
          countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return countryShort;
      }
    
      getCountry(place) {
        const COMPONENT_TEMPLATE = { country: 'long_name' },
          country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return country;
      }
    
      getPostCode(place) {
        const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
          postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return postCode;
      }
    
      getPhone(place) {
        const COMPONENT_TEMPLATE = { formatted_phone_number: 'formatted_phone_number' },
          phone = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return phone;
      }
      iniciar_geolocalizacion() {
        navigator.geolocation.getCurrentPosition(this.consulta.bind(this), this.manejo_errores.bind(this));
      }
      manejo_errores(error) {
        this.lat = 26.0667;
        this.ln = 50.55770000000007;
        switch (error.code) {
          case error.PERMISSION_DENIED: console.log('The user did not share their geographic location');
            break;
          case error.POSITION_UNAVAILABLE: console.log('The current geographic position could not be detected');
            break;
          case error.TIMEOUT: console.log('The waiting time has been exhausted when consulting geographical position');
            break;
          default: console.log('Unknown error');
            break;
        }
      }
      consulta(coordenadas) {
        const lat = coordenadas.coords.latitude;
        this.lat = lat;
        const lng = coordenadas.coords.longitude;
        this.ln = lng;
        this.agendaPro.latitude = String(this.lat);
        this.agendaPro.longitude = String(this.ln);
      }
}